import { useMemo, useState } from 'react'
import * as RegrasFreteHttp from '../../../../../services/api/https/registration/regras-frete.http'

import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING: 'Carregando',
}

const INITIAL_STATE = {
  regrasFaturamento: [],
  modal: {
    show: false,
    data: null,
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedTp: 0,
  globalFilter: '',
}

export default function useRegrasFaturamento() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      resetState() {
        setState({ ...INITIAL_STATE })
      },

      resetErrorMessage() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
          loadingMessage: LOAD_MESSAGE.NONE,
        }))
      },

      // Events
      onInit(selectedTp) {
        if (selectedTp === 0)
          return setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: 'Selecione um Operador Logístico',
          }))
        setState(prevState => ({
          ...prevState,
          selectedTp: selectedTp,
          loadingMessage: LOAD_MESSAGE.LOADING,
        }))
      },

      loadRegrasFaturamento(selectedTp) {
        RegrasFreteHttp.getRegrasFaturamento(selectedTp)
          .then(regrasFaturamento =>
            setState(prevState => ({
              ...prevState,
              regrasFaturamento: regrasFaturamento,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(error => {
            errorHandler(error)
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: 'Erro ao carregar regras de faturamento',
            }))
          })
      },

      onBtnNovo(selectedTp) {
        if (selectedTp === 0)
          return setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: 'Selecione um Operador Logístico',
          }))
        setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
      },

      onModalSave(regraFaturamento) {
        setState(prevState => {
          prevState.modal = { show: false, data: null }
          const index = prevState.regrasFaturamento.findIndex(aux => aux.id === regraFaturamento.id)
          if (index !== -1) prevState.regrasFaturamento[index] = regraFaturamento
          else prevState.regrasFaturamento.unshift(regraFaturamento)
          prevState.loadingMessage = LOAD_MESSAGE.NONE
          return { ...prevState }
        })
      },

      onDataTableItemClicked(regraFaturamento) {
        setState(prevState => ({
          ...prevState,
          modal: { show: true, data: { ...regraFaturamento } },
        }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
